'use client';

import React, { useMemo } from 'react';

import { usePathname } from 'next/navigation';

import { themeStyle } from '@repo/ui/theming';
import IconChevronRight from '@repo/ui-icons/IconChevronRight';

import { Label } from '../shared/Label/Label';

import { getLinksFromPath } from './getLinksFromPath';
import {
  BreadCrumbElement,
  BreadCrumbsContainer,
  BreadCrumbsWrapper,
} from './styles';
import { BreadCrumbProps } from './types';

const BreadCrumb: React.FC<BreadCrumbProps> = ({ links }) => {
  const pathname = usePathname();

  const linksToRender = useMemo(() => {
    if (links.length) {
      return links;
    } else {
      return getLinksFromPath(pathname ?? '');
    }
  }, [pathname, links]);

  return (
    <BreadCrumbsContainer>
      <BreadCrumbsWrapper>
        {linksToRender.map((link, index) => (
          <BreadCrumbElement key={link.url}>
            {index !== linksToRender.length - 1 ? (
              <>
                <Label label={link.label} url={link.url} />
                <IconChevronRight color={themeStyle.varInkMedium} size={16} />
              </>
            ) : (
              <Label activeStyle label={link.label} />
            )}
          </BreadCrumbElement>
        ))}
      </BreadCrumbsWrapper>
    </BreadCrumbsContainer>
  );
};

export default BreadCrumb;
